import React from 'react';
import LightBulb from '../../assets/images/lightbulb.svg';
import { textTitle3 } from '../../styles/typography';
import { classNames } from '../../utils/style';
export interface CalloutProps {
  title?: string;
  isLightbulbActive?: boolean;
  className?: string;
  children?: React.ReactNode;
}

export const Callout = ({
  title,
  isLightbulbActive,
  className,
  children,
}: CalloutProps) => {
  return (
    <section
      className={classNames(
        'Callout bg-blue-21 p-20 md:p-40 gap-6 flex flex-col rounded-12 relative text-neutral-301',
        className,
      )}
    >
      {title && (
        <div
          className={classNames(
            textTitle3,
            'text-20 leading-6 font-semibold',
            'md:text-24 md:leading-7',
            'bg-white w-fit max-w-[85%]',
            'inline-block rounded-6',
            'py-8 px-16',
          )}
        >
          {title}
        </div>
      )}

      {isLightbulbActive && (
        <LightBulb className="w-[100px] h-[100px] md:w-[130px] md:h-[130px] absolute top-[-30px] right-[-12px] md:top-[-40px]" />
      )}

      <div>{children && children}</div>
    </section>
  );
};
